import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungZwickau() {
  return (
    <CityPageTemplate
      city="Zwickau"
      slug="zwickau"
      intro="Zwickau als Automobilstadt in Sachsen – jetzt ist der richtige Zeitpunkt für smarten Vermögensaufbau."
      description="Unabhängige & digitale Finanzberatung für Zwickau: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
